function sleep(timeInMilliseconds = 0) {
  return new Promise((resolve) => setTimeout(() => resolve(true), timeInMilliseconds));
}

module.exports = { sleep };
